module.exports = __webpack_public_path__ + "img/image_5.bb809e10.png";